import Vue from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import Vuelidate from 'vuelidate';
import VueLazyload from "vue-lazyload";
import Meta from 'vue-meta';

Vue.use(Meta, {
  keyName: "metaInfo",
  attribute: "data-vue-meta",
  ssrAttribute: "data-vue-meta-server-rendered",
  tagIDKeyName: "vmid",
  refreshOnceOnNavigation: true,
});
Vue.use(VueLazyload);
Vue.use(Vuelidate);

Vue.config.productionTip = false;

window.axios = axios.create({
  baseURL: 'https://fibrillare.com.br/api/v1/public',
});

new Vue({
  router,
  data() {
    return {
      commonTexts: {},
      sliders: [],
      loadingImg: 0,
      cart: [],
      number: 0,
      updateTask: 0,
      mensagem: 'Mensagem',
      lastRoute: null,
    }
  },
  methods: {
    fetchCommonTexts() {
      window.axios.get('/common-texts')
          .then(r => {
              r.data.forEach(item => {
                  this.$set(this.commonTexts, item.identifier, item.content);
              });
          })
  },
  fetchSlides() {
    window.axios.get('/banners')
        .then(r => {
            r.data.forEach(item => {
                this.$set(this.sliders, item.identifier, item.images);
            });
        })
},
    fetchLocalStorage() {
      clearTimeout(this.updateTask);
      this.updateTask = setTimeout(() => this.fetchLocalStorage(), 500);

      if (window.localStorage.cart) {
        this.cart = JSON.parse(window.localStorage.cart);
      } else {
        this.cart = [];
      }

      this.number = this.cart.length;
    },
    addProduct(product) {
      let found = false;
      this.$root.cart.forEach((productBuffer) => {
        if (productBuffer.id === product.id) {
          found = true;
        }
      });

      if (!found) {
        product.quantity = 1;

        this.fetchLocalStorage();
        this.$root.cart.push(product);
        this.sendToLS();
      }

      return !found;
    },
    removeProduct(prodOffset) {
      this.$root.cart.splice(prodOffset, 1);
      this.sendToLS();
    },
    sendToLS() {
      this.number = this.cart.length;
      window.localStorage.setItem("cart", JSON.stringify(this.$root.cart));
    },
    increaseQuantity(index) {
      this.cart[index].quantity++;
      this.sendToLS();
    },
    decreaseQuantity(index) {
      if (this.cart[index].quantity >= 2) {
        this.cart[index].quantity--;
        this.sendToLS();
      }
    },
    setQuantity(index, quantity) {
      this.cart[index].quantity = quantity;
      this.sendToLS();
    },
  },
  mounted() {
    this.fetchSlides();
    this.fetchCommonTexts();

    this.updateTask = setTimeout(this.fetchLocalStorage(), 500);

      //O COUNTRY NÃO PARA 🤠 🤠 🤠 🤠 🤠 🤠 🤠 🤠 🤠
        this.$router.onReady(() => {
          this.$router.afterEach((to, from) => {
            if (to.path === '/produtos/aparadores' || to.path === '/produtos/bancos' || to.path === '/produtos/banquetas' || to.path === '/produtos/balancos-suspensos' || to.path === '/produtos/Bistrô' || to.path === '/produtos/cadeiras' || to.path === '/produtos/chaises' || to.path === '/produtos/lareiras' || to.path === '/produtos/espreguicadeira' || to.path === '/produtos/mesa-de-canto-centro' || to.path === '/produtos/mesas' || to.path === '/produtos/ombrelones'){

            window.location.reload();
            }
          });
        });
      // 🤠 🤠 🤠 🤠 🤠 🤠 🤠 🤠 🤠 🤠 🤠 🤠 🤠 🤠 
  },
  render: h => h(App),
}).$mount("#app");
